module.exports = function () {
  return new Worker(__webpack_public_path__ + "ab1946f182280cd7cafa.worker.js");
};